import React from 'react';
import AsyncPage from './async';
import DefaultConsumerLayout from '../../../../components/layout/DefaultConsumerLayout';

export default [
  <DefaultConsumerLayout
    key="/consumer/features/add-text-to-photo"
    exact
    path="/consumer/features/add-text-to-photo"
    component={AsyncPage}
  />,
];
